import { UploadFile } from "antd"
import { SectionQuestion } from "./SectionQuestion"

interface ContructorParams {
	id?: number
	name: string
	name_en: string
	name_ca: string
	description?: string
	description_en?: string
	description_ca?: string
	image?: string | UploadFile
	order?: number
	questions?: SectionQuestion[]
}
export class SurveySection {
	public readonly id?: number
	public readonly name: string
	public readonly name_en: string
	public readonly name_ca: string
	public readonly description?: string
	public readonly description_en?: string
	public readonly description_ca?: string
	public readonly image?: string | UploadFile
	public readonly order?: number
	public readonly questions?: SectionQuestion[]

	constructor(params: ContructorParams) {
		this.id = params.id
		this.name = params.name
		this.name_en = params.name_en
		this.name_ca = params.name_ca
		this.description = params.description
		this.description_en = params.description_en
		this.description_ca = params.description_ca
		this.image = params.image
		this.order = params.order
		this.questions = params.questions
	}
}
